var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"site-header"}},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.title}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }